import { render, staticRenderFns } from "./Fototextosombra.vue?vue&type=template&id=5e267d72&scoped=true&"
import script from "./Fototextosombra.vue?vue&type=script&lang=js&"
export * from "./Fototextosombra.vue?vue&type=script&lang=js&"
import style0 from "./Fototextosombra.vue?vue&type=style&index=0&id=5e267d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e267d72",
  null
  
)

export default component.exports